import {fileIcons, RagOutput} from "../../types/chat";
import DistanceMatchComponent from "./DistanceMatchComponent";
import {FaEye} from "react-icons/fa";
import {twMerge} from "tailwind-merge";

export enum BorderStyle {
    NONE = "",
    BOTTOM = "border-b",
    ALL = "rounded border",
}

export interface SourceDisplayerProps {
    rag: RagOutput;
    clickAction: () => void;
    percentages: boolean;
    className?: string;
    showEye?: boolean;
    borderStyle?: BorderStyle;
}

// Display the rag document list
export function SourceDisplayer({rag, clickAction, percentages, className, showEye = true, borderStyle=BorderStyle.ALL}: SourceDisplayerProps) {
    const Icon = fileIcons[rag.source_type] || fileIcons.pdf;
    const fileType = `Fichier ${rag.source_type || "pdf"}`;

    return (
        <div
            className={twMerge(borderStyle, "flex p-2 border-figmaColors-subBorder cursor-pointer text-xs gap-2 items-center hover:bg-gray-200 transition justify-between", className)}
            onClick={clickAction}
        >
            <div className="flex flex-row items-center justify-center gap-2">
                <img src={Icon} alt={fileType} data-tooltip-content={fileType} data-tooltip-id="main-tooltip" className="w-8 h-8 flex-shrink-0"/>
                <div className="flex flex-col gap-1">
                    <div className="font-semibold overflow-ellipsis w-full">{rag.source}</div>
                    <div className="font-medium">Page {rag.page}</div>
                </div>
            </div>
            <div className="flex flex-row items-center justify-center gap-4">
                <DistanceMatchComponent distance={rag.distance} maxDistance={32} percentages={percentages}/>
                {showEye && (
                    <FaEye
                        className="text-figmaColors-ActiveBlueInteraction flex-shrink-0 h-4 w-4"
                        data-tooltip-id="main-tooltip-right"
                        data-tooltip-content="Visualiser"
                    />
                )}
            </div>
        </div>
    );
}